import React, { useEffect, useState } from "react";
import { CountryMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import MainPopup from "../popup-containers/MainPopup";
import toast from "react-hot-toast";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import Buttons from "../components/Buttons";
import AddScreenTitle from "../components/AddScreenTitle";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Countrypopup from "../popup-containers/Countrypopup";
import Loader from "../ReusableComponents/Loader";

const Country = () => {
  const location = useLocation();

  const [country, setCountry] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [countryError, setCountryError] = useState("");
  const [countryCodeError, setCountryCodeError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [bindCountryMasterDatas, setBindCountryMasterDatas] = useState([]);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const [visibleSubmit, setVisibleSubmit] = useState(false);
  const [visibleAddScreenTitle, setVisibleAddScreenTitle] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [countryData, setCountryData] = useState({});
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [MstCountryId, setMstCountryId] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const createdBy = sessionStorage.getItem("createdBy");

  const showAdd = () => {
    setVisibleAdd(true);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setVisibleTable(false);
    setVisibleSubmit(true);
    setVisibleUpdate(false);
    setVisibleAddScreenTitle(true);
  };

  const cancel = () => {
    getCountryTableDatas();
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    setCountry("");
    setCountryCode("");
    setCountryError("");
    setCountryCodeError("");
    setIsLoading(false);
  };

  const handleEdit = (rowIndex) => {
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setVisibleSubmit(false);
    setVisibleUpdate(true);
    setVisibleAddScreenTitle(false);
    setMstCountryId(bindCountryMasterDatas[rowIndex].MstCountryId);
    setCountry(bindCountryMasterDatas[rowIndex].CountryName);
    setCountryCode(bindCountryMasterDatas[rowIndex].CountryCode);
  };

  const handleCountry = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setCountryData(bindCountryMasterDatas[rowIndex]);
  };

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  const getCountryTableDatas = async () => {
    setIsLoading(true);
    const response = await BindAPI("CountryAPI/BindCountry");
    setBindCountryMasterDatas(response.data.Table);
    setIsLoading(false);
  };

  useEffect(() => {
    getCountryTableDatas();
  }, []);

  useEffect(() => {
    if (location.pathname === "/countrymaster") {
      setVisibleTable(true);
      setVisibleAdd(false);
    }
  }, [location]);

  const handleSubmit = async (rowIndex, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    let nameValidate = "";
    let codeValidate = "";

    if (flag === 1 || flag === 2) {
      // Country Name Validation
      nameValidate =
        country.length > 0
          ? /^[A-Za-z ]+$/.test(country)
            ?// ? !visibleUpdate &&
              bindCountryMasterDatas.find(
                (x) => (x.CountryName?.toLowerCase?.() || "") === country.toLowerCase()
              )
              ? "Country already exists"
              : ""
            : "Only alphabets and spaces allowed"
          : "Enter Country";

      codeValidate =
        countryCode.length > 0
          ? /^[A-Z]{2}$/.test(countryCode)
            ? !visibleUpdate &&
              bindCountryMasterDatas.find(
                (x) => (x.CountryCode?.toLowerCase?.() || "") === countryCode.toLowerCase()
              )
              ? "Country code already exists"
              : ""
            : "Enter 2 uppercase characters"
          : "Enter Country Code";

      setCountryError(nameValidate);
      setCountryCodeError(codeValidate);

      if (nameValidate || codeValidate) {
        setIsOpen(true);
        setIsLoading(false);
         setSubmitBtnDisabled(false);
        return;
      }

      setIsOpen(false);

      const data = {
        mstCountryId: MstCountryId || 0,
        countryName: country,
        countryCode: countryCode,
        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI([data], "CountryAPI/IUDCountry");
      const result = response.data.Table[0].Result;

      if (flag === 1 && result === "S") {
        toast.success("Country added successfully 👍", {
          duration: 3000,
          position: "top-center",
        });
        setTimeout(cancel, 3000);
      } else if (flag === 2 && result === "M") {
        toast.success("Country updated successfully 👍", {
          duration: 3000,
          position: "top-center",
        });
        setTimeout(cancel, 3000);
      } else {
        toast.error(
          `Failed to ${flag === 1 ? "add" : "update"} Country 👎`,
          {
            duration: 3000,
            position: "top-center",
          }
        );
        setTimeout(cancel, 3000);
      }
    } else {
      const data = {
        mstCountryId: bindCountryMasterDatas[rowIndex].MstCountryId,
        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI([data], "CountryAPI/IUDCountry");
      const result = response.data.Table[0].Result;

      if (flag === 3 && result === "D") {
        toast.success("Country data deleted successfully! 👍", {
          duration: 3000,
          position: "top-center",
        });
        setTimeout(cancel, 3000);
      } else if (flag === 4 && result === "B") {
        toast.success("Country data inactivated successfully! 👍", {
          duration: 3000,
          position: "top-center",
        });
        setTimeout(cancel, 3000);
      } else if (flag === 5 && result === "UB") {
        toast.success("Country data activated successfully! 👍", {
          duration: 3000,
          position: "top-center",
        });
        setTimeout(cancel, 3000);
      } else {
        toast.error(
          `Failed to ${
            flag === 3 ? "delete" : flag === 4 ? "inactivate" : "activate"
          } Country data 👎`,
          {
            duration: 3000,
            position: "top-center",
          }
        );
        setTimeout(cancel, 3000);
      }
    }

    setIsLoading(false);
    // setSubmitBtnDisabled(false);
  };

  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title={"Country"}
          header={CountryMasterHeader}
          records={bindCountryMasterDatas}
          handleEdit={handleEdit}
          handleAction={handleCountry}
          showAdd={showAdd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div className="w-full">
          <div className="border-black">
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Country"
            />
          </div>
          <div className="mx-auto md:w-[500px] w-full border-black">
            <div className="relative w-full h-full max-w-xl md:h-auto">
              <div className="relative bg-white rounded-lg shadow">
                <div className="px-6 py-6 lg:px-8">
                  <form className="space-y-6">
                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title={"Country"}
                      name={"country"}
                      content={country}
                      controlFunc={(e) => setCountry(e.target.value)}
                      controlFuncBlur={(e) => {
                        const val = e.target.value.trim();
                        setCountry(val);
                        setCountryError(
                          val.length > 0
                            ? /^[A-Za-z ]+$/.test(val)
                             ? // ? !visibleUpdate &&
                                bindCountryMasterDatas.find(
                                  (x) =>
                                    (x.CountryName?.toLowerCase?.() || "") ===
                                    val.toLowerCase()
                                )
                                ? "Country already exists"
                                : ""
                              : "Only alphabets and spaces allowed"
                            : "Enter Country"
                        );
                      }}
                      errorMessage={countryError}
                    />
                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title={"Country Code"}
                      name={"countrycode"}
                      content={countryCode}
                      disabled={visibleUpdate}
                      controlFunc={(e) => setCountryCode(e.target.value)}
                      controlFuncBlur={(e) => {
                        const val = e.target.value.trim();
                        setCountryCode(val);
                        setCountryCodeError(
                          val.length > 0
                            ? /^[A-Z]{2}$/.test(val)
                             ? // ? !visibleUpdate &&
                                bindCountryMasterDatas.find(
                                  (x) =>
                                    (x.CountryCode?.toLowerCase?.() || "") ===
                                    val.toLowerCase()
                                )
                                ? "Country code already exists"
                                : ""
                              : "Enter 2 uppercase characters"
                            : "Enter Country Code"
                        );
                      }}
                      errorMessage={countryCodeError}
                    />
                  </form>
                  <Buttons
                    addScreenTitle={visibleSubmit}
                    updateScreenTitle={visibleUpdate}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled || isLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleCountry}
      >
        <div>
          <PopUpScreenTitle
            title="Country"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <Countrypopup data={countryData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Country;